import react from "react";

import mirowren1 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_001 copy Large.jpeg";
import mirowren2 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_002 copy Large.jpeg";
import mirowren3 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_003 copy Large.jpeg";
import mirowren4 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_004 copy Large.jpeg";
import mirowren5 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_005 copy Large.jpeg";
import mirowren6 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_006 copy Large.jpeg";
import mirowren7 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_007 copy Large.jpeg";
import mirowren8 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_008 copy Large.jpeg";
import mirowren9 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_009 Large.jpeg";
import mirowren10 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_010 copy Large.jpeg";
import mirowren11 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_011 copy Large.jpeg";
import mirowren12 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_012 copy Large.jpeg";
import mirowren13 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_013 copy Large.jpeg";
import mirowren14 from "../images/commercials/mirowren/KIDSPORTFOLIO_WITHBORDERS_2024_014 copy Large.jpeg";

const Mirowren = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={mirowren1} alt="Miro Wren Kids Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren2} alt="Miro Wren Kids Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren3} alt="Miro Wren Kids Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren4} alt="Miro Wren Kids Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren5} alt="Miro Wren Kids Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren6} alt="Miro Wren Kids Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren7} alt="Miro Wren Kids Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren8} alt="Miro Wren Kids Commercial Photography - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren9} alt="Miro Wren Kids Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren10} alt="Miro Wren Kids Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren11} alt="Miro Wren Kids Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren12} alt="Miro Wren Kids Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren13} alt="Miro Wren Kids Commercial Photography - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={mirowren14} alt="Miro Wren Kids Commercial Photography - Image 14"/>
                </div>
            </div>
        </div>
    );
}

export default Mirowren;